export function extractAuthPayload(response = {}) {
    const nested = response.data && typeof response.data === 'object' && !Array.isArray(response.data)
        ? response.data
        : {};
    return { ...response, ...nested };
}

export function extractAuthQrCode(payload = {}) {
    const direct = payload.qr_code ?? payload.qrCode ?? '';
    if (direct) {
        return String(direct);
    }

    try {
        const raw = payload.payload;
        if (!raw) {
            return '';
        }
        const decoded = JSON.parse(atob(raw));
        const token = decoded.otpToken ?? decoded.otp_token ?? '';
        if (token && String(token).startsWith('000201')) {
            return String(token);
        }
    } catch (e) {
        // ignore invalid payload
    }

    return '';
}

export function resolveOtpMode(payload = {}) {
    if (extractAuthQrCode(payload)) {
        return 'push';
    }

    const mode = String(payload.otp_mode ?? payload.otpMode ?? '').toLowerCase();
    if (['push', 'confirm', 'app'].includes(mode)) {
        return 'push';
    }
    if (['sms', 'otp'].includes(mode)) {
        return 'otp';
    }

    const msg = String(payload.auth_message ?? payload.authMessage ?? payload.message ?? '').toLowerCase();
    if (
        msg.includes('quét')
        || msg.includes('qr')
        || msg.includes('chờ xác thực')
        || msg.includes('smartbanking')
        || (msg.includes('app') && (msg.includes('xác nhận') || msg.includes('confirm')) && !msg.includes('otp sms') && !msg.includes('mã otp'))
    ) {
        return 'push';
    }

    return 'otp';
}

export function isAuthLoginComplete(response = {}) {
    const payload = extractAuthPayload(response);
    return payload.is_login === true || payload.isLogin === true;
}

export function isPushPending(response = {}) {
    const payload = extractAuthPayload(response);
    if (payload.push_pending === true || payload.pushPending === true) {
        return true;
    }
    const auth = getBankAccountAuth(response);
    return auth.otpMode === 'push' && !isAuthLoginComplete(response);
}

export function isChallengeExpired(response = {}) {
    const payload = extractAuthPayload(response);
    if (payload.challenge_expired === true || payload.challengeExpired === true) {
        return true;
    }
    const msg = String(response.message ?? payload.auth_message ?? payload.authMessage ?? '').toLowerCase();
    return msg.includes('hết hiệu lực') || msg.includes('het hieu luc');
}

export function getBankAccountAuth(payload = {}) {
    const data = extractAuthPayload(payload);
    const otpMode = data.otpMode ?? data.otp_mode ?? null;

    return {
        status: data.status,
        stateAuth: data.stateAuth ?? data.state_auth ?? null,
        requiresOtp: data.requiresOtp ?? data.requires_otp ?? false,
        otpMode: otpMode ? String(otpMode).toLowerCase() : resolveOtpMode(data),
        isLogin: data.isLogin ?? data.is_login ?? false,
        message: data.message ?? payload.message ?? '',
        authMessage: data.auth_message ?? data.authMessage ?? data.message ?? payload.message ?? '',
        qrCode: extractAuthQrCode(data),
        challengeExpired: data.challenge_expired === true || data.challengeExpired === true,
        nextStep: data.next_step ?? data.nextStep ?? null,
        qrRefreshed: data.qr_refreshed === true || data.qrRefreshed === true,
    };
}

export function needsOtpFromHandle(data = {}) {
    const { stateAuth, requiresOtp } = getBankAccountAuth(data);
    return stateAuth === 'otp' || requiresOtp === true;
}

export function isOtpRequestComplete(response = {}) {
    if (!response.success || isPushPending(response)) {
        return false;
    }
    const auth = getBankAccountAuth(response);
    return auth.isLogin === true || (auth.stateAuth === 'none' && !auth.requiresOtp);
}

export function isOtpReAuthSuccess(response = {}) {
    if (!response.success || isPushPending(response)) {
        return false;
    }
    const auth = getBankAccountAuth(response);
    if (auth.isLogin === true) {
        return true;
    }
    return auth.stateAuth === 'none' && !auth.requiresOtp;
}

export function shouldContinuePushWait(response = {}) {
    if (isPushPending(response)) {
        return true;
    }
    const auth = getBankAccountAuth(response);
    if (auth.otpMode === 'push' && !isAuthLoginComplete(response)) {
        return true;
    }
    const msg = String(auth.authMessage || auth.message || response.message || '').toLowerCase();
    return msg.includes('quét')
        || msg.includes('đang xử lý')
        || msg.includes('chờ xác thực')
        || msg.includes('chờ xác nhận')
        || msg.includes('xác nhận đăng nhập')
        || msg.includes('nhấn xác nhận')
        || msg.includes('techcombank');
}

export function parseAuthMethodsResponse(response = {}) {
    const data = response.data;
    if (Array.isArray(data)) {
        return {
            methods: data,
            note: null,
        };
    }
    if (data && typeof data === 'object') {
        return {
            methods: data.methods ?? [],
            note: data.note ?? null,
        };
    }
    return {
        methods: [],
        note: null,
    };
}
